export const NEWS_QUERY_KEY = ["news"] as const;
export const NEWS_ITEM_QUERY_KEY = ["news", "item"] as const;
export const NEWS_CATEGORIES_QUERY_KEY = ["news", "categories"] as const;
export const NEWS_BY_CATEGORY_QUERY_KEY = ["news", "by-category"] as const;
export const NEWS_SAVED_QUERY_KEY = ["news", "saved"] as const;
export const NEWS_DRAFT_QUERY_KEY = ["news", "draft"] as const;
export const NEWS_ALL_QUERY_KEY = ["news", "all"] as const;
export const QUERY_KEYS = {
  NEWS: ["news"],
};
export const NEWS_GLOBAL_QUERY_KEYS = {
  globalNews: ["global-news"],
} as const;
